"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBSCRIPTION_DEFAULT_TTL = exports.SUBSCRIPTION_EVENTS = void 0;
const time_1 = require("./time");
exports.SUBSCRIPTION_EVENTS = {
    payload: "subscription_payload",
    created: "subscription_created",
    updated: "subscription_updated",
    deleted: "subscription_deleted",
    enabled: "subscription_enabled",
    disabled: "subscription_disabled",
    sync: "subscription_sync",
};
exports.SUBSCRIPTION_DEFAULT_TTL = time_1.THIRTY_DAYS;
//# sourceMappingURL=subscription.js.map